import React from "react";

import FaderLogo from "./logo.js";

class TopStatic extends React.Component {
  render() {
    return (
      <FaderLogo />
    );
  }
}

export default TopStatic;
